"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
require('./robocop.css');
var React = require("react");
var ui_1 = require("../ui");
var Robocop = /** @class */ (function (_super) {
    __extends(Robocop, _super);
    function Robocop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Robocop.prototype.render = function () {
        return (React.createElement("div", { className: "progress" },
            React.createElement("div", { className: "indeterminate" })));
    };
    return Robocop;
}(ui_1.BaseComponent));
exports.Robocop = Robocop;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/robocop.js
 ** module id = 153
 ** module chunks = 0
 **/